import { FormConfig, createFormFromConfig } from './GenericFormTemplate';

// ============================================
// CONFIGURAÇÕES DOS FORMULÁRIOS DE RECESSO
// ============================================

// Pedido de Indulto Natalino
export const INDULTO_NATALINO_RECESSO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Indulto Natalino',
  description: 'Requerimento de indulto com base em decreto natalino',
  suggestedDocs: 'Certidão de execução, Atestado de bom comportamento e Processo de execução.',
  defaultPecaRebater: 'Processo de Execução',
  pecaRebaterHelper: 'Faça upload do processo de execução penal',
  infoTip: 'Demonstre o preenchimento dos requisitos do decreto de indulto vigente.',
};
export const IndultoNatalinoRecessoForm = createFormFromConfig(INDULTO_NATALINO_RECESSO_CONFIG);

// Ação Cautelar de Sustação de Protesto (Recesso)
export const SUSTACAO_PROTESTO_RECESSO_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Ação Cautelar de Sustação de Protesto',
  description: 'Medida urgente para impedir ou sustar protesto de título',
  suggestedDocs: 'Intimação do protesto, Título protestado e Provas da inexigibilidade.',
  infoTip: 'Demonstre a urgência e o direito de sustar o protesto indevido.',
};
export const SustacaoProtestoRecessoForm = createFormFromConfig(SUSTACAO_PROTESTO_RECESSO_CONFIG);

// Ação de Busca e Apreensão de Menor com Tutela de Urgência (Recesso)
export const BUSCA_APREENSAO_MENOR_RECESSO_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Ação de Busca e Apreensão de Menor com Tutela de Urgência',
  description: 'Medida urgente para localização e apreensão de menor',
  suggestedDocs: 'Certidão de nascimento, Decisão de guarda e Provas da situação de risco.',
  infoTip: 'Demonstre a situação de urgência e risco ao menor para justificar a medida.',
};
export const BuscaApreensaoMenorRecessoForm = createFormFromConfig(BUSCA_APREENSAO_MENOR_RECESSO_CONFIG);

// Contranotificação Extrajudicial
export const CONTRANOTIFICACAO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contranotificação Extrajudicial',
  description: 'Resposta formal a notificação extrajudicial recebida',
  suggestedDocs: 'Notificação recebida e Documentos comprobatórios.',
  defaultPecaRebater: 'Notificação Extrajudicial',
  pecaRebaterHelper: 'Indique a notificação que deseja responder',
  infoTip: 'Apresente sua versão dos fatos e conteste os termos da notificação recebida.',
};
export const ContranotificacaoForm = createFormFromConfig(CONTRANOTIFICACAO_CONFIG);

// Habeas Corpus (Recesso)
export const HABEAS_CORPUS_RECESSO_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Habeas Corpus',
  description: 'Ação constitucional para proteger a liberdade de locomoção',
  suggestedDocs: 'Auto de prisão, Decisão de custódia e Documentos comprobatórios da ilegalidade.',
  infoTip: 'Demonstre claramente a ilegalidade ou abuso de poder que constrange a liberdade do paciente.',
};
export const HabeasCorpusRecessoForm = createFormFromConfig(HABEAS_CORPUS_RECESSO_CONFIG);

// Impugnação à Penhora (Recesso)
export const IMPUGNACAO_PENHORA_RECESSO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Impugnação à Penhora',
  description: 'Defesa contra penhora de bens',
  suggestedDocs: 'Auto de penhora, Processo de execução e Provas de impenhorabilidade.',
  defaultPecaRebater: 'Auto de Penhora',
  pecaRebaterHelper: 'Indique o auto de penhora que deseja impugnar',
  infoTip: 'Demonstre a impenhorabilidade do bem ou outros vícios da penhora.',
};
export const ImpugnacaoPenhoraRecessoForm = createFormFromConfig(IMPUGNACAO_PENHORA_RECESSO_CONFIG);

// Inicial de Ação de Adjudicação Compulsória (Recesso)
export const ADJUDICACAO_COMPULSORIA_RECESSO_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Inicial de Ação de Adjudicação Compulsória',
  description: 'Ação para obter escritura de imóvel prometido à venda',
  suggestedDocs: 'Contrato de compra e venda, Comprovantes de pagamento e Matrícula do imóvel.',
  infoTip: 'Demonstre o cumprimento de todas as obrigações do comprador e a recusa do vendedor.',
};
export const AdjudicacaoCompulsoriaRecessoForm = createFormFromConfig(ADJUDICACAO_COMPULSORIA_RECESSO_CONFIG);

// Mandado de Segurança (Recesso)
export const MANDADO_SEGURANCA_RECESSO_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Mandado de Segurança',
  description: 'Proteção a direito líquido e certo violado por autoridade',
  suggestedDocs: 'Ato coator, Provas do direito líquido e certo e Documentos de identificação.',
  infoTip: 'Demonstre claramente o direito líquido e certo e a ilegalidade ou abuso de poder.',
};
export const MandadoSegurancaRecessoForm = createFormFromConfig(MANDADO_SEGURANCA_RECESSO_CONFIG);

// Manifestação Processual (Recesso)
export const MANIFESTACAO_RECESSO_CONFIG: FormConfig = {
  formType: 'resposta_com_tipo',
  title: 'Manifestação Processual',
  description: 'Manifestação genérica em processo judicial',
  suggestedDocs: 'Processo na íntegra.',
  defaultPecaRebater: '',
  pecaRebaterHelper: 'Ex. Despacho judicial feito na data de 21/05/2025',
  infoTip: 'Manifeste-se sobre o ponto específico determinado pelo juízo ou de interesse da parte.',
};
export const ManifestacaoRecessoForm = createFormFromConfig(MANIFESTACAO_RECESSO_CONFIG);

// Notificação Extrajudicial
export const NOTIFICACAO_EXTRAJUDICIAL_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Notificação Extrajudicial',
  description: 'Comunicação formal de fatos ou direitos',
  suggestedDocs: 'Documentos que embasam a notificação.',
  infoTip: 'Seja claro e objetivo quanto aos fatos, direitos e consequências pretendidas.',
};
export const NotificacaoExtrajudicialForm = createFormFromConfig(NOTIFICACAO_EXTRAJUDICIAL_CONFIG);

// Pedido de Cumprimento Provisório de Sentença (Recesso)
export const CUMPRIMENTO_PROVISORIO_RECESSO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Cumprimento Provisório de Sentença',
  description: 'Execução de sentença pendente de recurso',
  suggestedDocs: 'Cálculos, Processo na íntegra e Sentença.',
  defaultPecaRebater: 'Sentença',
  pecaRebaterHelper: 'Indique a sentença que será executada provisoriamente',
  infoTip: 'Demonstre a possibilidade de reversão e requeira a prestação de caução se necessário.',
};
export const CumprimentoProvisorioRecessoForm = createFormFromConfig(CUMPRIMENTO_PROVISORIO_RECESSO_CONFIG);

// Pedido de Expedição de RPV (Recesso)
export const RPV_RECESSO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Expedição de Requisição de Pequeno Valor (RPV)',
  description: 'Requerimento para pagamento de RPV',
  suggestedDocs: 'Cálculos homologados, Processo na íntegra e Sentença transitada.',
  defaultPecaRebater: 'Sentença',
  pecaRebaterHelper: 'Indique a sentença transitada em julgado',
  infoTip: 'Requeira a expedição da RPV após o trânsito em julgado, observando o teto legal.',
};
export const RPVRecessoForm = createFormFromConfig(RPV_RECESSO_CONFIG);

// Pedido de Levantamento de Valores
export const LEVANTAMENTO_VALORES_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Levantamento de Valores',
  description: 'Requerimento para saque de valores depositados judicialmente',
  suggestedDocs: 'Decisão que autorizou o levantamento e Processo na íntegra.',
  defaultPecaRebater: 'Decisão Judicial',
  pecaRebaterHelper: 'Indique a decisão que autorizou o levantamento',
  infoTip: 'Apresente os dados bancários e documentos necessários para o levantamento.',
};
export const LevantamentoValoresForm = createFormFromConfig(LEVANTAMENTO_VALORES_CONFIG);

// Pedido de Liberdade Provisória (Recesso)
export const LIBERDADE_PROVISORIA_RECESSO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Liberdade Provisória',
  description: 'Requerimento de liberdade provisória com ou sem fiança',
  suggestedDocs: 'Auto de prisão, Decisão de custódia e Comprovantes de residência e trabalho.',
  defaultPecaRebater: 'Auto de Prisão em Flagrante',
  pecaRebaterHelper: 'Indique o auto de prisão ou decisão de custódia',
  infoTip: 'Demonstre a ausência dos requisitos da prisão preventiva e vínculos com o distrito da culpa.',
};
export const LiberdadeProvisoriaRecessoForm = createFormFromConfig(LIBERDADE_PROVISORIA_RECESSO_CONFIG);

// Pedido de Penhora de Faturamento
export const PENHORA_FATURAMENTO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Penhora de Faturamento',
  description: 'Requerimento de penhora sobre faturamento de empresa',
  suggestedDocs: 'Execução, Pesquisas infrutíferas e Processo na íntegra.',
  defaultPecaRebater: 'Processo de Execução',
  pecaRebaterHelper: 'Faça upload do processo de execução',
  infoTip: 'Demonstre o esgotamento de outras diligências e a necessidade da medida.',
};
export const PenhoraFaturamentoForm = createFormFromConfig(PENHORA_FATURAMENTO_CONFIG);

// Pedido de Penhora no Rosto dos Autos
export const PENHORA_ROSTO_AUTOS_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Penhora no Rosto dos Autos',
  description: 'Requerimento de penhora sobre crédito em outro processo',
  suggestedDocs: 'Execução, Processo onde há o crédito e Pesquisas infrutíferas.',
  defaultPecaRebater: 'Processo de Execução',
  pecaRebaterHelper: 'Faça upload do processo de execução',
  infoTip: 'Indique o processo onde o devedor possui crédito a receber.',
};
export const PenhoraRostoAutosForm = createFormFromConfig(PENHORA_ROSTO_AUTOS_CONFIG);

// Pedido de Relaxamento de Prisão (Recesso)
export const RELAXAMENTO_PRISAO_RECESSO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Relaxamento de Prisão',
  description: 'Requerimento para relaxar prisão ilegal',
  suggestedDocs: 'Auto de prisão e Provas da ilegalidade.',
  defaultPecaRebater: 'Auto de Prisão',
  pecaRebaterHelper: 'Indique o auto de prisão que deseja atacar',
  infoTip: 'Demonstre a ilegalidade formal ou material da prisão.',
};
export const RelaxamentoPrisaoRecessoForm = createFormFromConfig(RELAXAMENTO_PRISAO_RECESSO_CONFIG);

// Pedido de Revogação de Prisão Preventiva (Recesso)
export const REVOGACAO_PREVENTIVA_RECESSO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Revogação de Prisão Preventiva',
  description: 'Requerimento para revogar prisão preventiva',
  suggestedDocs: 'Decisão de prisão preventiva e Processo na íntegra.',
  defaultPecaRebater: 'Decisão de Prisão Preventiva',
  pecaRebaterHelper: 'Indique a decisão que decretou a prisão preventiva',
  infoTip: 'Demonstre a cessação dos motivos que justificaram a prisão.',
};
export const RevogacaoPreventivaRecessoForm = createFormFromConfig(REVOGACAO_PREVENTIVA_RECESSO_CONFIG);

// Pedido de Revogação de Prisão Preventiva e Aplicação de Medidas Cautelares (Recesso)
export const REVOGACAO_PREVENTIVA_MEDIDAS_RECESSO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Revogação de Prisão Preventiva e Aplicação de Medidas Cautelares',
  description: 'Requerimento para substituir prisão por medidas cautelares',
  suggestedDocs: 'Decisão de prisão preventiva e Processo na íntegra.',
  defaultPecaRebater: 'Decisão de Prisão Preventiva',
  pecaRebaterHelper: 'Indique a decisão que decretou a prisão preventiva',
  infoTip: 'Demonstre que medidas cautelares são suficientes para o caso.',
};
export const RevogacaoPreventivaMedidasRecessoForm = createFormFromConfig(REVOGACAO_PREVENTIVA_MEDIDAS_RECESSO_CONFIG);

// Petição de Incidente (Execução Penal) (Recesso)
export const PETICAO_INCIDENTE_RECESSO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Petição de Incidente (Execução Penal)',
  description: 'Petição incidental em processo de execução penal',
  suggestedDocs: 'Processo de execução penal e Documentos do incidente.',
  defaultPecaRebater: 'Processo de Execução',
  pecaRebaterHelper: 'Faça upload do processo de execução penal',
  infoTip: 'Apresente o pedido incidental com fundamentação adequada.',
};
export const PeticaoIncidenteRecessoForm = createFormFromConfig(PETICAO_INCIDENTE_RECESSO_CONFIG);

// Tutela Provisória Antecipada Antecedente
export const TUTELA_ANTECIPADA_ANTECEDENTE_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Tutela Provisória Antecipada Antecedente',
  description: 'Tutela de urgência antecipada requerida antes da ação principal',
  suggestedDocs: 'Provas da urgência e do direito.',
  infoTip: 'Demonstre a probabilidade do direito e o perigo de dano ou risco ao resultado útil.',
};
export const TutelaAntecipadaAntecedenteForm = createFormFromConfig(TUTELA_ANTECIPADA_ANTECEDENTE_CONFIG);

// Tutela Provisória Cautelar Antecedente
export const TUTELA_CAUTELAR_ANTECEDENTE_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Tutela Provisória Cautelar Antecedente',
  description: 'Tutela cautelar requerida antes da ação principal',
  suggestedDocs: 'Provas da urgência e do direito.',
  infoTip: 'Demonstre o fumus boni iuris e o periculum in mora.',
};
export const TutelaCautelarAntecedenteForm = createFormFromConfig(TUTELA_CAUTELAR_ANTECEDENTE_CONFIG);

// Tutela Provisória Antecipada Incidental
export const TUTELA_ANTECIPADA_INCIDENTAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Tutela Provisória Antecipada Incidental',
  description: 'Tutela de urgência antecipada no curso do processo',
  suggestedDocs: 'Processo na íntegra e Provas da urgência.',
  defaultPecaRebater: 'Processo',
  pecaRebaterHelper: 'Faça upload do processo em andamento',
  infoTip: 'Demonstre fatos novos ou agravamento da situação que justifiquem a tutela.',
};
export const TutelaAntecipadaIncidentalForm = createFormFromConfig(TUTELA_ANTECIPADA_INCIDENTAL_CONFIG);

// Tutela Provisória da Evidência (Recesso)
export const TUTELA_EVIDENCIA_RECESSO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Tutela Provisória da Evidência',
  description: 'Tutela baseada na evidência do direito, independente de urgência',
  suggestedDocs: 'Processo na íntegra e Provas do direito evidente.',
  defaultPecaRebater: 'Processo',
  pecaRebaterHelper: 'Faça upload do processo em andamento',
  infoTip: 'Demonstre uma das hipóteses do art. 311 do CPC (abuso de defesa, prova documental, etc.).',
};
export const TutelaEvidenciaRecessoForm = createFormFromConfig(TUTELA_EVIDENCIA_RECESSO_CONFIG);

// Tutela Provisória Cautelar Incidental
export const TUTELA_CAUTELAR_INCIDENTAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Tutela Provisória Cautelar Incidental',
  description: 'Tutela cautelar no curso do processo',
  suggestedDocs: 'Processo na íntegra e Provas da urgência.',
  defaultPecaRebater: 'Processo',
  pecaRebaterHelper: 'Faça upload do processo em andamento',
  infoTip: 'Demonstre a necessidade de assegurar o resultado útil do processo.',
};
export const TutelaCautelarIncidentalForm = createFormFromConfig(TUTELA_CAUTELAR_INCIDENTAL_CONFIG);
